<template>
    <div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isAuthenticated: true,
            preview: false,
            api_url: this.$store.state.API_URL[process.env.VUE_APP_ENV],
            dynamic_url: "",
            connectedSeller: "Connect Now",
            connectedAdvertising: "Connect Now",
            org_id: 0,
            hide_panel: {},
            connect: {},
            api: "Amazon-Seller",
            obj: {
                comparison: "India",
            },
            sHow: false,
        }
    },
    created() {
        if (this.$org_id.label == null && this.$org_id.label === undefined && this.$org_id.label == "") {
            var productsURL = this.api_url + "/multiuser/get_accessable_org_list";
            this.$http.post(productsURL).then((response) => {
                if (response.data != 0) {
                    this.$org_id.label = response.data[0]['org_id'];
                    this.orgNameDisplay = response.data[0]['org_name'];
                    console.log("this.$org_id.label",this.$org_id.label)
                    if (this.$org_id.label == null && this.$org_id.label === undefined && this.$org_id.label == "") {
                        this.$q.loading.hide();
                    }
                    else{
                        this.connection('Amazon-Seller');
                        this.connection("Amazon-Advertising");
                    }
                }
            }).catch(() => {
                    this.$q.loading.hide();
                });
        }
        else {
            this.connection('Amazon-Seller');
            this.connection("Amazon-Advertising");
        }
    },
    methods: {
        connection(item) {
            if (item == 'Amazon-Advertising') {
                this.$q.loading.show({
                    message: "Loading your data please wait..",
                });
                var user_url = this.api_url + "/amazon-ad/ad_user_exists/" + this.$org_id.label;
                this.$http
                    .post(user_url)
                    .then((response) => {
                        if (response.data.length == 0) {
                            this.$router.push("/home/" + this.$org_encryprt.label);
                        }
                        else {
                            this.connectedAdvertising = 'Connected'
                            this.homeDashboard();
                        }
                    }).catch((err) => {
                        this.$q.notify({
                            message: err,
                            color: "negative",
                        });
                    });
            }
            else {
                this.$q.loading.show({
                    message: "Loading your data please wait..",
                });
                var user_url = this.api_url + "/products/user_exists/" + this.$org_id.label;
                this.$http.post(user_url).then((response) => {
                    if (response.data.length == 0) {
                        this.$router.push("/home/" + this.$org_encryprt.label);
                    } else {
                        let URL = this.api_url + "/products/get_asins_details/" + this.$org_id.label;
                        this.$http
                            .post(URL)
                            .then((response) => {
                                let result = response;
                                this.connectedSeller = "Connected";
                                this.homeDashboard();
                            })
                            .catch((err) => {
                                this.$q.notify({
                                    message: err,
                                    color: "negative",
                                });
                            });
                    }
                });
            }
        },
        getStringBetween(str, start, end) {
            const result = str.match(new RegExp(start + "(.*)" + end));
            if (result == null) {
                return null
            }
            else {
                return result[1]
            }
        },
        homeDashboard() {
            if (this.connectedAdvertising == 'Connected' && this.connectedSeller == 'Connected') {
                this.$router.push("/homedashboard/" + this.$org_encryprt.label);
            }
        },
    }
}

</script>
<style></style>